import React from 'react';
import { Link } from 'react-router-dom';
import { Library, ClipboardList, Sliders, History } from 'lucide-react';
import PageIntro from '../components/ui/PageIntro';
import '../styles/classifier.css';

export default function RequirementsLibraryPage() {
  return <div className="workspace-page classifier-page">
    <PageIntro icon={Library} title="Библиотека требований" description="Здесь настраиваются правила для новых проверок. Для подготовки конкретного аудита используйте мастер — редактировать библиотеку не требуется." />
    <section className="classifier-panel preparation-start">
      <div><h2>Нужно провести аудит?</h2><p>Выберите компанию и её деятельность. Система предложит вопросы и покажет, что ещё нужно уточнить.</p></div>
      <Link className="ap-button ap-button--primary" to="/audit-preparation">Подготовить аудит</Link>
    </section>
    <div className="preparation-library-grid">
      {[
        [ClipboardList, 'Что проверять', 'Направления деятельности, требования, применимость и связи. Редактор для тех, кто поддерживает библиотеку.', '/classifier', 'Открыть редактор требований'],
        [Sliders, 'Как оценивать', 'Категории поставщиков, правила назначения требований и параметры квалификационной оценки.', '/supplier-settings', 'Открыть правила оценки'],
        [History, 'Обновления библиотеки', 'Импорт Excel, проверка изменений, публикация редакций и история. Черновик не меняет действующие аудиты.', '/classifier?tab=exchange', 'Управлять обновлениями'],
      ].map(([Icon, title, description, to, label]) => <article className="classifier-panel classifier-stack" key={to}>
        <Icon size={24} aria-hidden="true" /><h2>{title}</h2><p>{description}</p>
        {to === '/supplier-settings' && <Link to="/qualification?tab=methods">Критерии, веса и шкалы оценки</Link>}
        <Link className="ap-button ap-button--secondary" to={to}>{label}</Link>
      </article>)}
    </div>
    <p className="classifier-notice">Каждый созданный аудит сохраняет свою редакцию требований. Новая публикация не заменяет вопросы, ответы и доказательства в существующих аудитах.</p>
  </div>;
}
